module.exports = "https://www.gc-qa.gnp.com.mx/2b1ba1b78f9916c5868c7b0b3003d03c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/izquierda.svg
// module id = 1849
// module chunks = 0